var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNutritionIcons = function SvgNutritionIcons(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33.648,
    height: 33.106,
    viewBox: "0 0 33.648 33.106",
    fill: "#FFF",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1163",
    "data-name": "Rectangle 1163",
    width: 33.648,
    height: 33.106
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(-926.521 -351.126)",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(926.521 351.126)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24-2",
    "data-name": "Group 24",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M968.593,351.126h-.92L962.156,373.2l3.678,1.839-1.849,6.166a2.354,2.354,0,0,0,2.254,3.031h0a2.354,2.354,0,0,0,2.354-2.354Z",
    transform: "translate(-949.938 -351.126)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M935.717,351.126v7.817a1.379,1.379,0,1,1-2.759,0v-7.817h-1.839v7.817a1.379,1.379,0,1,1-2.759,0v-7.817h-1.839v10.541a2.5,2.5,0,0,0,1.212,2.141l2.029,1.217a2.5,2.5,0,0,1,1.2,2.389l-1.407,14.072a2.5,2.5,0,1,0,4.968,0l-1.407-14.072a2.5,2.5,0,0,1,1.2-2.389l2.029-1.217a2.5,2.5,0,0,0,1.212-2.141V351.126Z",
    transform: "translate(-926.521 -351.126)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M1002.836,391.358l-1.578,16.565a2.509,2.509,0,1,0,4.995,0l-1.578-16.565Z",
    transform: "translate(-975.627 -377.564)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M1003.506,358.483c0,4.063-2.47,7.357-5.518,7.357s-5.518-3.294-5.518-7.357,2.47-7.357,5.518-7.357,5.518,3.294,5.518,7.357",
    transform: "translate(-969.859 -351.126)"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNutritionIcons, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nutrition-icons.342efe46.svg";
export { ForwardRef as ReactComponent };